module.exports = __webpack_public_path__ + "static/media/block-image.8a4a14d5.svg";